import type { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { buildPathFromState, getRouteByName, routeMatchesPath, ROUTE_MANIFEST } from '@root/app/routing/routeManifest';

let navigateRef: NavigateFunction | null = null;
let currentPathname = '/';

export const setRouterNavigate = (navigate: NavigateFunction): void => {
    navigateRef = navigate;
};

export const setCurrentPathname = (pathname: string): void => {
    currentPathname = pathname;
};

export const navigateToState = (
    stateName: string,
    params?: Record<string, unknown>,
    options?: NavigateOptions
): void => {
    const path = buildPathFromState(stateName, params);
    if (navigateRef) {
        navigateRef(path, options);
        return;
    }

    window.location.assign(path);
};

export const isStateActive = (statePrefix: string, pathname: string = currentPathname): boolean => {
    const exact = getRouteByName(statePrefix);
    if (exact && routeMatchesPath(exact.path, pathname)) {
        return true;
    }

    return ROUTE_MANIFEST.some((route) => {
        const nameMatches = route.name === statePrefix || route.name.startsWith(`${statePrefix}.`);
        return nameMatches && routeMatchesPath(route.path, pathname);
    });
};

export const reloadCurrentRoute = (): void => {
    if (navigateRef) {
        navigateRef(0);
    }
};

/** Post-login navigation: accepts a legacy state name or an absolute path (e.g. from ?redirect=). */
export const navigateAfterLogin = (
    redirect?: string | null,
    params?: Record<string, unknown>
): void => {
    const target = redirect || 'private.dashboard';
    if (target.startsWith('/')) {
        const normalized = target.replace(/\/+$/, '') || '/';
        if (navigateRef) {
            navigateRef(normalized);
            return;
        }
        window.location.assign(normalized);
        return;
    }
    navigateToState(target, params);
};
